import { render, staticRenderFns } from "./proposalList.vue?vue&type=template&id=607496b6&"
import script from "./proposalList.vue?vue&type=script&lang=js&"
export * from "./proposalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports